import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { User } from 'app/projects/user/src/lib/models/user';

export function canAccessExecutionMetadata(user: Pick<User, 'permissions'> | null | undefined, moduleKind?: ModuleKind | null): boolean {
    if (!user?.permissions?.length) {
        return false;
    }

    if (moduleKind !== undefined && moduleKind !== null) {
        const isExecutionKind = moduleKind === ModuleKind.Execution || moduleKind === ModuleKind.ProgramExecution;
        if (!isExecutionKind) {
            return false;
        }
    }

    return (
        user.permissions.includes(AdminPermissions.TENANT_MANAGEMENT) ||
        user.permissions.includes(AdminPermissions.COURSES_READ) ||
        user.permissions.includes(AdminPermissions.COURSES_WRITE)
    );
}
